import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiteContainerComponent } from './site-container.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SiteContainerRoutingModule } from './site-container-routing.module';
import { GlobalUIComponentsModule } from '../ui-components/global/global-ui-components.module';
import { MatDialogModule } from '@angular/material/dialog';
import { SiteWideDalogModule } from './site-wide-dialog/site-wide-dialog.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [
        SiteContainerComponent,
        NotFoundComponent
    ],
    imports: [
        CommonModule,
        SiteContainerRoutingModule,
        GlobalUIComponentsModule,
        MatDialogModule,
        SiteWideDalogModule,
        MatButtonModule,
        MatIconModule,
    ]
})
export class SiteContainerModule { }
